export const FETCH_BARCODE_DATA_REQUEST = "FETCH_BARCODE_DATA_REQUEST";
export const FETCH_BARCODE_DATA_SUCCESS = "FETCH_BARCODE_DATA_SUCCESS";
export const FETCH_BARCODE_DATA_FAILURE = "FETCH_BARCODE_DATA_FAILURE";
